import React, { useCallback, useContext, useMemo, useState } from "react";
import { useQueryClient } from "react-query";

import zoningApi from "services/zoningApi";

const LocaleContext = React.createContext("en");

export const LocaleProvider = ({ initialLocale, children }) => {
  const [locale, setLocale] = useState(initialLocale);
  const contextValue = useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [locale, setLocale],
  );

  return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => {
  const { locale } = useContext(LocaleContext);
  return locale;
};

export const useSetLocale = () => {
  const { setLocale } = useContext(LocaleContext);
  const queryClient = useQueryClient();

  const onChangeLocale = useCallback(
    async (locale) => {
      setLocale(locale);
      document.cookie = `locale=${locale}; path=/; max-age=31536000; SameSite=Lax`;
      zoningApi.locale = locale;
      await queryClient.invalidateQueries();
    },
    [setLocale, queryClient],
  );

  return onChangeLocale;
};
